import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Card } from "@/components/ui/Card";
import { MOCK_ENGAGEMENT_30D } from "@/components/mocks/fixtures";
import type { DashboardEngagementPoint } from "@/lib/dashboard";

interface Props {
  data?: DashboardEngagementPoint[];
}

export function EngagementChart({ data }: Props = {}) {
  const series = data && data.some((d) => d.active > 0) ? data : MOCK_ENGAGEMENT_30D;
  return (
    <Card surface="base" className="p-7">
      <p className="font-mono text-[11px] uppercase tracking-[0.08em] text-[var(--color-slate-200)] mb-5">
        Member engagement · last 30 days
      </p>
      <div className="h-[180px] -ml-2">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={series}>
            <defs>
              <linearGradient id="engagement-fill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#56c2ff" stopOpacity={0.18} />
                <stop offset="100%" stopColor="#56c2ff" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis
              dataKey="day"
              tick={{ fill: "#6a6b6c", fontSize: 10, fontFamily: "var(--font-mono)" }}
              tickLine={false}
              axisLine={{ stroke: "#363739", strokeOpacity: 0.4 }}
              interval={6}
              tickFormatter={(v) => `D${v}`}
            />
            <YAxis
              hide
            />
            <Tooltip
              cursor={{ stroke: "#363739", strokeOpacity: 0.5, strokeWidth: 1 }}
              contentStyle={{
                background: "rgba(7,8,10,0.95)",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: 8,
                fontSize: 12,
              }}
              labelStyle={{ color: "#9c9c9d", fontFamily: "var(--font-mono)" }}
              itemStyle={{ color: "#ffffff" }}
              formatter={(v: number) => [v.toLocaleString(), "active"]}
              labelFormatter={(v: number) => `Day ${v}`}
            />
            <Area
              type="monotone"
              dataKey="active"
              stroke="#56c2ff"
              strokeWidth={1.5}
              fill="url(#engagement-fill)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
